(function () {
  var initializedRoots = new WeakSet();

  function initHeaderUtilities(root) {
    if (initializedRoots.has(root)) return;

    var toggle = root.querySelector('[data-pd-search-toggle]');
    var form = root.querySelector('.pd-header-utilities__search');
    var input = root.querySelector('.pd-header-utilities__search-input');
    if (!toggle || !form || !input) return;

    initializedRoots.add(root);

    function isOpen() {
      return root.classList.contains('pd-header-utilities--search-open');
    }

    function openSearch() {
      root.classList.add('pd-header-utilities--search-open');
      toggle.setAttribute('aria-expanded', 'true');
      form.removeAttribute('hidden');
      window.requestAnimationFrame(function () {
        input.focus();
      });
    }

    function closeSearch(resetInput) {
      root.classList.remove('pd-header-utilities--search-open');
      toggle.setAttribute('aria-expanded', 'false');
      form.setAttribute('hidden', '');
      if (resetInput) input.value = '';
    }

    toggle.addEventListener('click', function (event) {
      event.preventDefault();
      if (isOpen()) closeSearch(true);
      else openSearch();
    });

    form.addEventListener('submit', function (event) {
      if (input.value.trim() === '') {
        event.preventDefault();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && isOpen()) closeSearch(true);
    });

    document.addEventListener('click', function (event) {
      if (isOpen() && !root.contains(event.target)) closeSearch(true);
    });

    if (input.value.trim() !== '') openSearch();
  }

  function boot() {
    document.querySelectorAll('[data-pd-header-utilities]').forEach(initHeaderUtilities);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target;
    if (!target || !target.querySelectorAll) return;
    target.querySelectorAll('[data-pd-header-utilities]').forEach(initHeaderUtilities);
  });
})();
